import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquaresStacked = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.4001 9.6H18.0001V18H9.6001V14.4",
		stroke: "currentColor",
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.4 6H6V14.4H14.4V6Z",
		stroke: "currentColor",
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgSquaresStacked);
export default ForwardRef;
